import template from './push_delivery_log.html';

angular.module('bb.appointments').component('pushDeliveryLog', {
  transclude: true,
  bindings: { deliveryLog: '<' },
  controller: () => {},
  controllerAs: 'vm',
  template,
});
